import React from 'react'
import {modular, sidebar} from "../../util/constants";
import Link from "next/link";
import {useRouter} from "next/router";
const Sidebar = ({show}) => {
    const router = useRouter()
    // console.log(router.pathname)
    return(
        <>
            <div id='sidebar' className={"sidebar-container " + (show && 'show')}>
                {sidebar.map(category => {
                    return(
                        <div key={category.name} className="category">
                            <div className="category-name">{category.name}</div>
                            {category.elements.map(element => {
                                const url = '/' + (category.url || category.name) + '/' + (element.url || element.name)
                                return(
                                    <Link key={element.name} href={url}>
                                        <div className={"sidebar-point " + (router.pathname && 'active')}>{element.name}</div>
                                    </Link>
                                )
                            })}
                        </div>
                    )
                })}
                <div className="footer">
                    {modular.footer}
                </div>
            </div>
        </>
    )
}

export default Sidebar